import { Recipe } from "./types";

// Drinks Recipes - Single source of truth for all drinks descriptions
export const drinksRecipes: Record<string, Recipe> = {
  liqueur: {
    id: "liqueur",
    name: "Liqueur",
    nameFr: "Liqueur",
    nameKey: "recipes.liqueur.name",
    description:
      "A selection of refreshing canned soft drinks served chilled for a crisp and satisfying taste.",
    descriptionFr:
      "Une sélection de liqueurs en canette servies bien froides pour un goût rafraîchissant et agréable.",
    descriptionKey: "recipes.liqueur.description",
  },

  "soda-can": {
    id: "soda-can",
    name: "Soda Can",
    nameFr: "Canette",
    nameKey: "recipes.sodaCan.name",
    description:
      "Classic canned soda served ice-cold to enhance its bright, bubbly flavour.",
    descriptionFr:
      "Canette de soda classique servie bien froide pour mettre en valeur son goût pétillant et rafraîchissant.",
    descriptionKey: "recipes.sodaCan.description",
  },

  "tea-herbal-tea": {
    id: "tea-herbal-tea",
    name: "Tea / Herbal Tea",
    nameFr: "Thé, tisane",
    nameKey: "recipes.tea.name",
    description:
      "A comforting selection of hot teas and soothing herbal infusions, prepared fresh to order.",
    descriptionFr:
      "Une sélection réconfortante de thés chauds et de tisanes apaisantes, préparée fraîchement à la demande.",
    descriptionKey: "recipes.tea.description",
  },

  "glass-of-milk": {
    id: "glass-of-milk",
    name: "Glass of Milk",
    nameFr: "Verre de lait",
    nameKey: "recipes.milk.name",
    description:
      "A chilled glass of fresh, creamy milk served smooth and refreshing.",
    descriptionFr:
      "Un verre de lait frais et onctueux, servi bien froid pour un rafraîchissement tout en douceur.",
    descriptionKey: "recipes.milk.description",
  },

  "glass-of-juice": {
    id: "glass-of-juice",
    name: "Glass of Juice",
    nameFr: "Verre de jus",
    nameKey: "recipes.juice.name",
    description:
      "A refreshing glass of fruit juice served cold, offering bright, natural flavor.",
    descriptionFr:
      "Un verre de jus de fruits rafraîchissant servi bien froid, offrant une saveur naturelle et éclatante.",
    descriptionKey: "recipes.juice.description",
  },

  "soft-drink-can": {
    id: "soft-drink-can",
    name: "Soft Drink (Can)",
    nameFr: "Liqueur (Canette)",
    nameKey: "recipes.softDrinkCan.name",
    description:
      "Refreshing canned soft drink served chilled for a crisp, satisfying taste.",
    descriptionFr:
      "Liqueur en canette servie bien froide pour un goût rafraîchissant et agréable.",
    descriptionKey: "recipes.softDrinkCan.description",
  },

  "filter-coffee": {
    id: "filter-coffee",
    name: "Filter Coffee",
    nameFr: "Café filtre",
    nameKey: "recipes.filterCoffee.name",
    description: "Freshly brewed filter coffee with a smooth, aromatic finish.",
    descriptionFr:
      "Café filtre fraîchement infusé offrant une finale aromatique et douce.",
    descriptionKey: "recipes.filterCoffee.description",
  },

  espresso: {
    id: "espresso",
    name: "Espresso",
    nameFr: "Espresso",
    nameKey: "recipes.espresso.name",
    description:
      "Rich, bold espresso shot crafted from finely ground premium beans.",
    descriptionFr:
      "Expresso riche et corsé préparé avec des grains de café de qualité.",
    descriptionKey: "recipes.espresso.description",
  },

  cappuccino: {
    id: "cappuccino",
    name: "Cappuccino",
    nameFr: "Cappuccino",
    nameKey: "recipes.cappuccino.name",
    description:
      "Classic cappuccino made with velvety steamed milk and a bold espresso base.",
    descriptionFr:
      "Cappuccino classique préparé avec un espresso corsé et un lait vapeur onctueux.",
    descriptionKey: "recipes.cappuccino.description",
  },

  "tea-herbal": {
    id: "tea-herbal",
    name: "Tea, Herbal Tea",
    nameFr: "Thé, tisane",
    nameKey: "recipes.teaHerbal.name",
    description:
      "A selection of comforting hot teas and soothing herbal infusions.",
    descriptionFr:
      "Une sélection de thés chauds réconfortants et de tisanes apaisantes.",
    descriptionKey: "recipes.teaHerbal.description",
  },

  milk: {
    id: "milk",
    name: "Glass of Milk",
    nameFr: "Verre de lait",
    nameKey: "recipes.milk.name",
    description: "A chilled glass of fresh milk served smooth and creamy.",
    descriptionFr:
      "Un verre de lait frais et froid, servi onctueux et agréable.",
    descriptionKey: "recipes.milk.description",
  },

  juice: {
    id: "juice",
    name: "Glass of Juice",
    nameFr: "Verre de jus",
    nameKey: "recipes.juice.name",
    description: "A refreshing glass of fruit juice served chilled.",
    descriptionFr:
      "Un verre de jus de fruits rafraîchissant, servi bien froid.",
    descriptionKey: "recipes.juice.description",
  },
};
